import Vue from 'vue';
import Vuex from 'vuex';
import {isMobile, isAndroid, isIOS, isMobileSafari, isChrome} from 'mobile-device-detect';

Vue.use(Vuex);

const isIosUA = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent);
};
const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);

export default new Vuex.Store({
  state: {
    user: {},
    viewName: 'loader',
    modalContent:'',
    modalFlag:false,
    modalBlocker:true,
    Code:'    ',
  },
  mutations: {
    setView: function (state, value) {
      state.viewName = value;
    },
    setContent: function (state, value) {
      state.modalContent = value;
    },
    showModal: function (state) {
      state.modalFlag = true;
    },
    hideModal: function (state) {
      state.modalFlag = false;
    },
    userCanCloseModal: function (state) {
      state.modalBlocker = true;
    },
    userCanNotCloseModal: function (state) {
      state.modalBlocker = false;
    },
    setCode: function (state, value) {
      state.Code = value;
    }

  },
  actions: {
    choiceView: ({commit, dispatch}) => {
      if (isMobile != true) {
        commit('setView', 'browserError');
        return false;
      }

      if (isIOS && isMobileSafari) {
        if (isIosUA() && !isInStandaloneMode()) {
          commit('setView', 'iosInstall');
        } else {
          commit('setView', 'verificationCode');
        }
        return false;
      }

      if (isAndroid) {
        if (window.matchMedia('(display-mode: standalone)').matches) {
          commit('setView', 'verificationCode');
        } else {
          commit('setView', 'androidInstall');
        }
        return false;
      }

      commit('setView', 'browserError');
    }
  },
  getters: {
    showThisView: (state => (thisView) => {
      return thisView == state.viewName;
    }),
    getCode: state => state.Code,
  }
})
